// Production: set RAZZLE_GOOGLE_MAPS_API_KEY in deployment (CSJ key with domain restrictions).
// Local dev: optional separate key with localhost in Google referrer restrictions, or leave unset.
export const getGoogleMapsApiKey = () =>
  process.env.RAZZLE_GOOGLE_MAPS_API_KEY ||
  process.env.GOOGLE_MAPS_API_KEY ||
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
  '';
